;(function () {
  angular
    .module('contrast.services.filter', [])
    .factory('FilterService', function () {
      return {
        containsTag: function (tags, searchKeywords) {
          var containsTag = _.find(tags, function (tag) {
            if (
              tag.toLowerCase().indexOf(searchKeywords.toLowerCase() || '') !==
              -1
            ) {
              return true
            }
          })
          return containsTag
        }
      }
    })
})()
